import React, { useEffect } from 'react'
import './smartbip.styles.scss'
import ecommerce from '../../Assets/ecommerce.png'
import fidelity from '../../Assets/fidelity.png'
import inventory from '../../Assets/inventory.png'
import selfscanning from '../../Assets/selfscanning.png'
import { ReactComponent as Check } from '../../Assets/check.svg'
import { ReactComponent as Right } from '../../Assets/arrow-right.svg'
import { Button } from '@mui/material'
import Ending from '../../Components/Ending/Ending'
import { useNavigate } from 'react-router'
import { useTranslation } from 'react-i18next'
import { Helmet } from 'react-helmet-async'

const Smartbip = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [])

    return (
        <div className='smartbip'>
            <Helmet>
                <meta itemProp="name" content="Chi siamo" />
                <meta
                    itemProp='description'
                    content="SmartBip è una piattaforma che consente ai retailer di trasformare i loro punti vendita in uno smart retail."
                />
            </Helmet>
            <div className='title'>
                <div className='small-title' aria-label={t("smartbip.subtitle")}>
                    {t("smartbip.subtitle")}
                </div>
                <div className='big-title' aria-label={t("smartbip.title")}>
                    {t("smartbip.title")}
                </div>
                <div className='list-container'>
                    {[1, 2, 3].map(i => (
                        <div className='list' key={i}>
                            <div>
                                <Check aria-label="Check icon" />
                            </div>
                            <div>
                                <label aria-label={t(`smartbip.check${i}`)}>
                                    {t(`smartbip.check${i}`)}
                                </label>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
            <div className='categories'>
                <div>
                    <label>
                        <label
                            style={{ fontSize: '26px', fontWeight: 'bold' }}
                            aria-label={t("footer.ecommerce")}
                        >
                            {t("footer.ecommerce")}
                        </label><br /><br />
                        <span aria-label={t("smartbip.ecommerce")}>{t("smartbip.ecommerce")}</span><br /><br />
                        <Button
                            variant='text'
                            onClick={() => navigate("/smartbip/ecommerce")}
                            aria-label={t("discovermore")}
                        >
                            {t("discovermore")} <Right />
                        </Button>
                    </label>
                </div>
                <div>
                    <img src={ecommerce} alt="E-commerce illustration" aria-label="E-commerce illustration" />
                </div>
            </div>
            <div className='categories left'>
                <div>
                    <img src={selfscanning} alt="Self-scanning illustration" aria-label="Self-scanning illustration" />
                </div>
                <div>
                    <label>
                        <label
                            style={{ fontSize: '26px', fontWeight: 'bold' }}
                            aria-label={t("footer.selfscanning")}
                        >
                            {t("footer.selfscanning")}
                        </label><br /><br />
                        <span aria-label={t("smartbip.selfscanning")}>{t("smartbip.selfscanning")}</span><br /><br />
                        <Button
                            variant='text'
                            onClick={() => navigate("/smartbip/selfscanning")}
                            aria-label={t("discovermore")}
                        >
                            {t("discovermore")} <Right />
                        </Button>
                    </label>
                </div>
            </div>
            <div className='categories'>
                <div>
                    <label>
                        <label
                            style={{ fontSize: '26px', fontWeight: 'bold' }}
                            aria-label={t("footer.inventory")}
                        >
                            {t("footer.inventory")}
                        </label><br /><br />
                        <span aria-label={t("smartbip.inventory")}>{t("smartbip.inventory")}</span><br /><br />
                        <Button
                            variant='text'
                            onClick={() => navigate("/smartbip/inventory")}
                            aria-label={t("discovermore")}
                        >
                            {t("discovermore")} <Right />
                        </Button>
                    </label>
                </div>
                <div>
                    <img src={inventory} alt="Inventory illustration" aria-label="Inventory illustration" />
                </div>
            </div>
            <div className='categories left'>
                <div>
                    <img src={fidelity} alt="Fidelity illustration" aria-label="Fidelity illustration" />
                </div>
                <div>
                    <label>
                        <label
                            style={{ fontSize: '26px', fontWeight: 'bold' }}
                            aria-label={t("footer.fidelity")}
                        >
                            {t("footer.fidelity")}
                        </label><br /><br />
                        <span aria-label={t("smartbip.fidelity")}>{t("smartbip.fidelity")}</span><br /><br />
                        <Button
                            variant='text'
                            onClick={() => navigate("/smartbip/fidelity")}
                            aria-label={t("discovermore")}
                        >
                            {t("discovermore")} <Right />
                        </Button>
                    </label>
                </div>
            </div>
            <Ending text={t("smartbip.ending")} aria-label={t("smartbip.ending")} />
        </div>

    )
}

export default Smartbip